function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function addProductToRecentlyViewed(productHandle) {
  let recentlyViewed = getCookie('recently_viewed')
    ? JSON.parse(getCookie('recently_viewed'))
    : [];
  if (!recentlyViewed.includes(productHandle)) {
    recentlyViewed.push(productHandle);
  }

  if (recentlyViewed.length > 6) {
    recentlyViewed.shift();
  }

  setCookie('recently_viewed', JSON.stringify(recentlyViewed), 30);
}

function displayRecentlyViewed(callback) {
  const recentlyViewed = getCookie('recently_viewed')
    ? JSON.parse(getCookie('recently_viewed'))
    : [];

  if (recentlyViewed.length > 0) {
    const container = document.querySelector(
      '.product-recommendations__panel.most_recently_viewed__container',
    );

    if (container) {
      container.innerHTML = '';

      const productPromises = recentlyViewed.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((response) => response.json())
          .then((product) => {
            const firstVariant = product.variants[0];
            const hasMultipleImages = product.images.length > 1;

            let discountHTML = '';
            if (firstVariant.compare_at_price) {
              const percentage =
                ((firstVariant.compare_at_price - firstVariant.price) /
                  firstVariant.compare_at_price) *
                100;
              discountHTML = `<div class='product-tile__tags-label product-tile__tags-label--percentage'>-${Math.round(percentage)}%</div>`;
            }

            let remainingTags = 2;
            const tagHTML = product.tags
              .map((tag) => {
                if (remainingTags < 0) {
                  return;
                }

                if (tag.includes('TAG__')) {
                  remainingTags--;
                  return `<div class="product-tile__tags-label">${tag.replace('TAG__', '')}</div>`;
                } else return '';
              })
              .join('');

            const mediaHTML = product.images
              .map(
                (image) => `
                <div class="swiper-slide">
                  <div class="media__container">
                    <img srcset="${image} 800w"
                        src="${image}"
                        alt="${product.title}"
                        class="media"
                        width="800"
                        height="600"
                        loading="lazy">
                  </div>
                </div>
              `,
              )
              .join('');

            // Wishlist button
            const wishlistHTML = `
            <div class='product-tile__wishlist' data-wishlist-btn data-wishlist-status
              data-wishlist-variant-id='${firstVariant.id}'
              data-wishlist-product-id='${product.id}'
              data-wishlist-product-url='${window.location.origin}${product.url}'
              data-wishlist-price='${(firstVariant.price / 100).toFixed(2)}'
              data-wishlist-compare-at-price='${
                firstVariant.compare_at_price
                  ? (firstVariant.compare_at_price / 100).toFixed(2)
                  : ''
              }'>
              <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule="evenodd" clip-rule="evenodd" d="M15.9815 9.12331C13.5 4.50001 3.27574 4.03073 4.0277 13.2251C4.41822 18 16.0301 27.3334 16.0301 27.3334C16.0301 27.3334 27.5858 18 28 13.1722C28.7841 4.0336 18.5 4.50006 15.9815 9.12331Z" stroke="var(--light__ui_element)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
          `;

            // color option (not used)
            // const colorOptionsHTML = product.options.includes('Color')
            //   ? `<div class='product-tile__colors'>${product.options
            //       .find((o) => o.name === 'Color')
            //       .values.map((color) => `<span>${color}</span>`)
            //       .join('')}</div>`
            //   : '';

            // size option (not used)
            // const sizeOptionsHTML = product.options.includes('Size')
            //   ? `<div class='product-tile__sizes'>${product.options
            //       .find((o) => o.name === 'Size')
            //       .values.map(
            //         (size) =>
            //           `<div class='product-tile__sizes-label'>${size}</div>`,
            //       )
            //       .join('')}</div>`
            //   : '';

            const productHTML = `
            <div class="product-tile__container swiper-slide">

              <a href="${product.url}" class="product-tile__gallery">
                <div class='swiper-wrapper'>${mediaHTML}</div>
                ${
                  hasMultipleImages
                    ? `
                    <div class='product-tile__gallery-controls'>
                      <div class='product-tile__gallery-arrow product-tile__gallery-arrow--left'><svg class='chevron-left' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule="evenodd" clip-rule="evenodd" d="M9.46282 13.7062L4.62834 8.33453C4.4572 8.14438 4.4572 7.85572 4.62834 7.66556L9.46282 2.29392L10.2061 2.96288L5.67267 8.00005L10.2061 13.0372L9.46282 13.7062Z" fill="var(--light__ui_element)"/></svg></div>
                      <div class='product-tile__gallery-arrow product-tile__gallery-arrow--right'><svg class='chevron-right' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule="evenodd" clip-rule="evenodd" d="M6.53718 2.29382L11.3717 7.66547C11.5428 7.85562 11.5428 8.14428 11.3717 8.33443L6.53718 13.7061L5.79388 13.0371L10.3273 7.99995L5.79388 2.96279L6.53718 2.29382Z" fill="var(--light__ui_element)"/></svg></div>
                    </div>`
                    : ''
                }
                <div class='product-tile__tags'>${discountHTML}${tagHTML}</div>
                ${wishlistHTML}
              </a>
              <div class='product-tile__info'>
                <h5 class="product-tile__vendor">${product.vendor}</h5>
                <a href="${product.url}" class='product-tile__title'><h4>${product.title}</h4></a>
                <div class='product-tile__price'>
                  ${
                    firstVariant.compare_at_price
                      ? `<del>${(firstVariant.compare_at_price / 100).toFixed(
                          2,
                        )}</del>`
                      : ''
                  }
                  <span>${(firstVariant.price / 100).toFixed(2)}</span>
                </div>
              </div>

            </div>
          `;

            return productHTML;
          }),
      );

      Promise.all(productPromises).then((productsHTML) => {
        container.innerHTML = productsHTML.join('');
        if (typeof window.dAgency?.initProductTile === 'function') {
          container
            .querySelectorAll('.product-tile__container')
            .forEach((tile) => window.dAgency.initProductTile(tile));
        }
        if (callback) {
          callback();
        }
      });
    }
  }
}

// function startRecentlyViewdCarousel() {
//   new Swiper('.product-recommendations__panels', {
//     loop: true,
//     slidesPerView: 1.5,
//     spaceBetween: 4,
//     breakpoints: {
//       [parseInt(breakpoints.lg.replace('px', ''))]: {
//         slidesPerView: 6,
//       },
//     },
//   });
// }

document.addEventListener('DOMContentLoaded', function () {
  const productContainer = document.querySelector('.product-page__section');
  if (productContainer) {
    const url = window.location.pathname;
    const productHandle = url.split('/').pop();

    if (productHandle) {
      addProductToRecentlyViewed(productHandle);
    }
  }

  displayRecentlyViewed();
});
